import { ApolloError, useQuery } from '@apollo/client';
import { READ_ONGOING_CHARGING_SESSION } from '@queries/readOngoingChargingSession';
import useIsLoggedIn from 'hooks/useIsLoggedIn';
import { useEffect } from 'react';
import { useChargingStore } from 'stores/chargingStore';
import { ChargingSession, Maybe, Query } from 'types/generatedSchemaTypes';

const useOngoingChargingSession = (
  bypassCache = false
): {
  ongoingChargingSession?: Maybe<ChargingSession>;
  ongoingChargingSessionError?: ApolloError;
  ongoingChargingSessionStartPolling: (pollInterval: number) => void;
  ongoingChargingSessionStopPolling: () => void;
  ongoingChargingSessionRefetch: () => void;
  ongoingChargingSessionLoading: boolean;
} => {
  const { isLoggedIn } = useIsLoggedIn();
  const { data, error, startPolling, stopPolling, refetch, loading } =
    useQuery<Query>(READ_ONGOING_CHARGING_SESSION, {
      fetchPolicy: bypassCache ? 'network-only' : 'cache-and-network',
      skip: !isLoggedIn,
    });

  const { chargingSessionId } = data?.readOngoingChargingSessionV3 || {};

  useEffect(() => {
    useChargingStore
      .getState()
      .setOngoingChargingSession(chargingSessionId || '');
  }, [chargingSessionId]);

  return {
    ongoingChargingSession: data?.readOngoingChargingSessionV3,
    ongoingChargingSessionError: error,
    ongoingChargingSessionStartPolling: startPolling,
    ongoingChargingSessionStopPolling: stopPolling,
    ongoingChargingSessionRefetch: refetch,
    ongoingChargingSessionLoading: loading,
  };
};

export default useOngoingChargingSession;
